import type { SxProps, Theme } from "~/common/mui";
import CPDProgress from "~/features/cms/homepagePersonalization/cpd/components/cpdProgress/CPDProgress";
import { useCustomerPerformanceProgress } from "~/features/cms/homepagePersonalization/cpd/customerPerformanceApi";

type Props = {
  totalCartValue?: number;
  sx?: SxProps<Theme>;
};

export default function ConnectedCPDProgress({ totalCartValue, sx }: Props) {
  const { data } = useCustomerPerformanceProgress();

  if (!data) {
    return null;
  }

  const { label, invoice, gap, target, targetIndex, currency } = data;
  return (
    <CPDProgress
      totalCartValue={totalCartValue}
      sx={sx}
      label={label}
      invoice={invoice}
      target={target}
      targetIndex={targetIndex ?? undefined}
      currency={currency}
      gap={gap}
    />
  );
}
